import { Injectable } from '@angular/core';
import { PopupMessageComponent } from './popup-message/popup-message.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  bsModalRef!: BsModalRef;

  constructor(private bsModalService: BsModalService) {}

  confirm(popupDispalyObj: any, className?: string, insuredInformation?: any) {
    const initialState = {
      popupDispalyObj: popupDispalyObj,
      insuredInformation: insuredInformation,
    };
    
    this.bsModalRef = this.bsModalService.show(PopupMessageComponent, {
      initialState,
    });
    
    if (className) {
      this.bsModalRef.setClass(className);
      
      // THE ACTUAL FIX: Hide the Angular Material dialog when modal opens
      if (className === 'send-via-modal-above-pdf') {
        setTimeout(() => {
          // Hide the PDF dialog temporarily
          const pdfDialog = document.querySelector('.pdf-viewer-dialog') as HTMLElement;
          if (pdfDialog) {
            pdfDialog.style.display = 'none';
          }
          
          // Set high z-index for modal
          const modal = document.querySelector('.modal.show:last-child') as HTMLElement;
          const backdrop = document.querySelector('.modal-backdrop:last-child') as HTMLElement;
          
          if (modal) {
            modal.style.zIndex = '99999';
            modal.style.position = 'fixed';
          }
          if (backdrop) {
            backdrop.style.zIndex = '99998';
            backdrop.style.position = 'fixed';
          }
        }, 10);
      }
    }
    
    return new Observable<string[]>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer: any) => {
      const subscription = this.bsModalService.onHidden.subscribe(
        (reason: string[]) => {
          observer.next(this.bsModalRef.content.popupCallbackDetail);
          observer.complete();
          
          // Restore the PDF dialog visibility
          const pdfDialog = document.querySelector('.pdf-viewer-dialog') as HTMLElement;
          if (pdfDialog) {
            pdfDialog.style.display = '';
          }
        }
      );

      return {
        unsubscribe() {
          subscription.unsubscribe();
        },
      };
    };
  }
}
